<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
// import Home from './views/Home';

export default {
  name: 'App',
  // components: {
  //   Home
  // }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #538db8;
}
* {
  padding: 0;
  margin: 0;
}
html, body {
  margin: 0 !important;
  padding: 0 !important;
  height: 100%;
  overflow-x: hidden;
}

/* 重置视频标签默认样式 */
video {
  display: block;
  max-width: 100%;
  height: auto;
  vertical-align: bottom;
  line-height: 0;
}

/* 重置图片标签默认样式 */
img {
  display: block;
  max-width: 100%;
  height: auto;
  vertical-align: bottom;
}
</style>
